﻿// JavaScript Document
(function ($) {
    $(function () {
        const checkFundMenuOverflow = () => {
            if ($(window).innerHeight() < 850) {
                $('div.menu-item-wrapper div.drop').addClass('ss-overflow');
            } else {
                $('div.menu-item-wrapper div.drop').removeClass('ss-overflow');
            }

            if ($(window).innerHeight() < 670) {
                $('div.menu-item-wrapper div.drop').addClass('smaller-drop-element');
            } else {
                $('div.menu-item-wrapper div.drop').removeClass('smaller-drop-element');
            }
        }

        checkFundMenuOverflow();

        //On scroll event hide swipe button
        $(".table-container-m").on("scroll", function () {
            var cur = $(this).scrollLeft();
            if (cur > 45) {
                $(this).find('.swipe-column').hide();
            }
        });
        $(".table-container-m").trigger("scroll");

        //If table are long then 20 rows, position swipe text to the top of the table 
        $('.table-container-m').each(function () {
            var $this = $(this);
            if ($this.find('tr').length > 20) {
                $this.find('.swipe-column').css("vertical-align", "top");
            }
        });
        //Add text to the first table in the class called swipe-column
        //$(".swipe-column:first").html('Swipe<br />to view <br /> full data<br /><span class="fa fa-arrows-h"></span>');
        //Add text to the all table in the class called swipe-column
        $(".swipe-column").html('Swipe<br />to view <br /> full data<br /><span class="fa fa-arrows-h"></span>');


        //if table has srcoll bars

        $('.table-container-m').each(function () {
            if ($(this)[0].scrollWidth > $(this).width()) {
                $(this).find('.swipe-column').css("display", "table-cell");
            }
            else if ($(window).width() > 768) {
                $(this).find('.swipe-column').css("display", "none");
            }
            else {
                $(this).find('.swipe-column').css("display", "none");
            }
        });

        $(window).resize(function () {
            $('.table-container-m').each(function () {
                if ($(this)[0].scrollWidth > $(this).width()) {
                    $(this).find('.swipe-column').css("display", "table-cell");
                }
                else if ($(window).width() > 768) {
                    $('.table-container-m').find('.swipe-column').css("display", "none");

                }
                else {
                    $(this).find('.swipe-column').css("display", "none");
                }
            });
            if ($(window).width() > 768) {
                /*$('body').removeClass('push-right');*/
                $('body').removeClass('close-body');
                /*$('body div').removeClass('push-right');*/
                $('body div').removeClass('close-nav');
                $('#mobile-nav').removeClass('js-ready');
                $('#mobile-nav ul').removeClass('open');
            }
            if ($(window).width < 992) {
                $('.header-search-overlay').removeClass('active');
                $('body, .wrapper, footer').removeClass('blur');
            }

            checkFundMenuOverflow();
        });

        //open object
        $('.menuBtn').click(function () {
            $('.menu-mobile > ul').toggleClass('open');
        });
        $('.close-nav-b').click(function () {
            $('.menu-mobile > ul').toggleClass('open');
        });
        $('.mobileBtn').click(function () {
            $(this).toggleClass('open');
        });
        $('.close-nav-b').click(function () {
            $('.close-nav-b').toggleClass('close-nav');
        });
        $('.menuBtn').click(function () {
            $('.close-nav-b').toggleClass('close-nav');
        });

        $('.close-nav-b').click(function () {
            $('.close-nav-b').removeClass('nav-hide');
            $(this).addClass('nav-hide');
        });

        //$('.menuBtn').click(function () {
        //    $('.push-right').toggleClass('close-body');
        //});
        //$('.close-nav-b').click(function () {
        //    $('.push-right').toggleClass('close-body');
        //});

        $('.mobileBtn').click(function () {
            $(this).parent('li').toggleClass('open');
        });
        $('.btn-search-m').click(function () {
            $('.outer-bg-search').toggleClass('open');
        });
        $('.btn-search-m').click(function () {
            $('.top-search').toggleClass('open');
        });

        $('.close-nav-b').click(function () {
            $('.menu-mobile').toggleClass('js-ready');
        });
        $('.menuBtn').click(function () {
            $('.menu-mobile').toggleClass('js-ready');
        });

        //$('.close-nav-b').click(function () {
        //    $('.mobile-push').toggleClass('push-right');
        //});
        //$('.menuBtn').click(function () {
        //    $('.mobile-push').toggleClass('push-right');
        //});

        // Mobile Redesign
        var mobileMethods = {
            onMenuItemClick: function (properties) {
                if (properties.childMenu.indexOf('level-1-m') > -1) {       // reset the active state of all level0 items
                    var isContextActive = $(properties.context).hasClass('active');
                    $('ul.menu-m a.level0').removeClass('active');

                    isContextActive ? $(properties.context).removeClass('active') : $(properties.context).addClass('active');
                }

                var isMenuActive = $(properties.context).parent().find(properties.childMenu).hasClass('active');
                $(properties.mainMenu + ' ' + properties.childMenu).removeClass('active');
                $(properties.mainMenu + ' ' + properties.childMenu).css({ 'transform': 'translateX(' + (window.innerWidth * -1) + 'px)' });

                if (!isMenuActive) {         // if menu was already active, we don't want to activate it again                  
                    $(properties.context).parent().find(properties.childMenu).toggleClass('active');
                    $(properties.mainMenu + ' ' + properties.childMenu + '.active').css({ 'transform': 'translateX(' + (window.innerWidth) + 'px)' });
                }
            },
            onSearchSubmit: function () {
                var searchString = $('#overlay-search-input').val();

                if (searchString) {
                    window.location.href = "/search/?searchtext=" + encodeURIComponent(decodeURIComponent(searchString));
                }
            },
            setMenuLayerPositioning: function () {
                $('ul.menu-m ul.level-1-m, ul.menu-m ul.level-3-m').each(function () {
                    $(this).css({ 'left': window.innerWidth * -1 });
                });

                $('ul.menu-m ul.level-1-m').css({ 'max-height': window.innerHeight - 136 + 'px', 'overflow': 'auto' });
            },
            checkMenuOrientationSwitchOverflow: function () {
                if (window.innerWidth > window.innerHeight) {
                    $('#mobile-nav').css({ 'overflow-y': 'scroll', 'overflow-x': 'hidden' });
                } else {
                    $('#mobile-nav').css({ 'overflow-y': 'visible', 'overflow-x': 'visible' });
                }

                if (window.innerWidth > 991 && $('.page-overlay').hasClass('active')) {
                    $('.page-overlay').addClass('screen-orientation-switched').removeClass('active');
                    return;
                }

                if ($('.page-overlay').hasClass('screen-orientation-switched')) {
                    $('.page-overlay').addClass('active').removeClass('screen-orientation-switched');
                }
            }
        };

        var isMenuOpen = false;
        var isSearchOpen = false;
        var isCloseAhp = false;

        window.addEventListener('closeAhp', function () {
            isCloseAhp = true;

            setTimeout(function () { isCloseAhp = false }, 1000);
        });

        $('.menuBtn').click(function () {
            if (isCloseAhp) return;         // don't close the menu if mobile AHP is closed

            $('ul.menu-m a.level0').removeClass('active');      // reset angle arrow state
            $('.mobile-menu').toggleClass('active');

            if (!$('.mobile-menu').hasClass('active')) {
                $('ul.menu-m ul.level-1-m').removeClass('active');
                $('ul.menu-m ul.level-1-m').css({ 'transform': 'translateX(' + (window.innerWidth * -1) + 'px)' });
            }

            if (!isMenuOpen) {
                if (isSearchOpen) {
                    isSearchOpen = !isSearchOpen;
                    $('.page-overlay').removeClass('search-active');
                } else {
                    $('.page-overlay').addClass('active')
                }
            } else {
                $('.page-overlay').removeClass('active');
            }

            isMenuOpen = !isMenuOpen;
        });

        $(function () {
            $('.head_li').click(function () {
                $(this).siblings().toggleClass('sub_li');
            });
        });

        mobileMethods.checkMenuOrientationSwitchOverflow();
        mobileMethods.setMenuLayerPositioning();

        var width = $(window).width();
        var orientationSwitchTimer;

        $(window).resize(function () {
            if (width != $(window).width()) {
                mobileMethods.checkMenuOrientationSwitchOverflow();
                mobileMethods.setMenuLayerPositioning();

                if (window.innerWidth > window.innerHeight) {
                    clearInterval(orientationSwitchTimer);
                    orientationSwitchTimer = setInterval(function () {
                        if ($('.screen-orientation-switched').hasClass('active')) {
                            $('.screen-orientation-switched').removeClass('active');
                        } else {
                            clearInterval(orientationSwitchTimer);
                        }
                    }, 500);
                }


                $('ul.level-1-m').each(function () {        // fixes menu visual defect when orientation changes
                    if ($(this).hasClass('active')) {
                        $('.menuBtn').trigger('click');
                        return;
                    }
                });

                width = $(window).width();
            }
        });

        $('ul.menu-m a.level0').click(function () {
            mobileMethods.onMenuItemClick({ mainMenu: 'ul.menu-m', childMenu: 'ul.level-1-m', context: this });
        });

        $('ul.menu-m a.level2').click(function () {
            mobileMethods.onMenuItemClick({ mainMenu: 'ul.menu-m', childMenu: 'ul.level-3-m', context: this });
        });

        $('.search-btn-container').click(function () {
            $('#mobile-nav, ul.menu-m ul.level-1-m').removeClass('active');
            $('ul.menu-m ul.level-1-m').css({ 'transform': 'translateX(' + (window.innerWidth * -1) + 'px)' });
            //$('.page-overlay').toggleClass('active search-active');

            if (!isSearchOpen) {
                if (isMenuOpen) {
                    isMenuOpen = !isMenuOpen;
                    $('.page-overlay').addClass('search-active');
                } else {
                    $('.page-overlay').addClass('active search-active');
                }
            } else {
                $('.page-overlay').removeClass('active search-active');
            }

            isSearchOpen = !isSearchOpen;
        });

        $('#overlay-search-submit').click(function (e) {
            mobileMethods.onSearchSubmit();
        });

        $('#overlay-search-input').on('keypress', function (e) {
            if (e.which == 13) {
                mobileMethods.onSearchSubmit();
            }
        });

        $('.etf-panel-top .left').click(function () {
            $(this).toggleClass('active');
            $('.etf-panel-vertical').toggleClass('active');
            $('#expand-etf').toggleClass('fa-plus-square');
            $('#expand-etf').toggleClass('fa-minus-square');
        });

        $('.etf-panel-bottom .fully-stretched').click(function () {
            $(this).toggleClass('active');
            window.location.href = 'performance/vaneck-vectors-etfs/equity-etfs/';
        });

        $(document).ready(function () {
            var isBlogPage = window.location.href.indexOf('blog') > -1;

            if (isBlogPage) {
                $('.mobile-menu li').css({ 'padding': '4px' });
                $('#mobile .l-right').css({ 'margin-right': '5%' });
            }

            setTimeout(function () {
                $('.level-1-m, .level-2-m').css({ 'opacity': '1' });;
            });
        });

        // New SiteHeader
        $(document).on('click.bs.dropdown.data-api', '.site-header__mobile-submenu', (event) => {
            if (!isInsideElement(event, 'a') && !isInsideElement(event, 'button')) {
                event.stopPropagation();
            }
        });

        $(document).on('click.bs.dropdown.data-api', '.site-header__mobile-submenu-toggle', () => {
            scrollToTop();
        });

        $(document).on('click.bs.dropdown.data-api', '.site-header__submenu .list-group-item-action', (event) => {
            event.stopPropagation();
        });

        $(document).on('click.bs.dropdown.data-api', '.site-header__submenu', (event) => {
            if (!isInsideElement(event, 'a') && !isInsideElement(event, 'button')) {
                event.stopPropagation();
            }
        });

        $('.site-header__submenu-action').on('mouseenter', (event) => {
            const actionElement = $(event.target),
                menuId = actionElement.attr('data-menu'),
                descriptionId = actionElement.attr('data-description'),
                currentActiveAction = $('#' + menuId + ' .list-group .list-group-item.active'),
                currentActivePane = $('#' + menuId + ' .site-header__submenu-content .tab-pane.active'),
                targetPane = $('#' + menuId + ' .site-header__submenu-content .tab-pane#' + descriptionId);

            $('#' + menuId + ' .site-header__submenu-content').attr('data-pane', currentActiveAction.attr('data-default'));
            currentActivePane.removeClass('show active');
            targetPane.addClass('show active');
        });

        $('.site-header__submenu-action').on('mouseleave', (event) => {
            const actionElement = $(event.target),
                menuId = actionElement.attr('data-menu'),
                descriptionId = actionElement.attr('data-description'),
                currentActiveAction = $('#' + menuId + ' .list-group .list-group-item.active'),
                currentActiveActionTarget = currentActiveAction.attr('data-default'),
                currentActivePane = $('#' + menuId + ' .site-header__submenu-content .tab-pane#' + descriptionId),
                newActivePane = $('#' + menuId + ' .site-header__submenu-content .tab-pane#' + currentActiveActionTarget);

            currentActivePane.removeClass('show active');
            newActivePane.addClass('show active');
        });

        $('.site-header__nav-link.navbar-toggler').on('click', (event) => {
            const toggleElement = $(".site-header__nav-link.navbar-toggler"),
                targetId = toggleElement.attr('data-target'),
                targetElement = $(targetId);

            toggleElement.toggleClass('collapsed');
            targetElement.toggleClass('show');
        });

        $('.site-header__mobile-submenu-toggle').on('click', (event) => {
            const toggleElement = $(event.target),
                targetId = toggleElement.attr('data-target'),
                targetElement = $(targetId);

            targetElement.toggleClass('show');
        });


        $('.site-header__mobile-sub-submenu-toggle').on('click', (event) => {
            const toggleElement = $(event.target),
                targetId = toggleElement.attr('data-target'),
                targetElement = $(targetId);

            targetElement.toggleClass('show');
        });
    });
})(jQuery);
